import { createContext, useContext } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { IContactFlags } from 'clickNgo/entities/contactFlag'

export interface ContactDataContextType {
  contact: IContact
  contactFlags: IContactFlags
}

export const ContactDataContext = createContext<ContactDataContextType | null>(null)

export const useContactData = (): ContactDataContextType => {
  const context = useContext(ContactDataContext)
  if (!context) {
    throw new Error('useContactData must be used within ContactDataProvider')
  }
  return context
}
